import '../css/CEOHistory.css' ;
import Text from '../../../common/Text.js';
import CEO2024 from '../img/CEOImage.png';
import CEO하태민 from '../img/CEO하태민.png';
import CEO이기영 from '../img/CEO이기영.png';
import CEO이교성 from '../img/CEO이교성.png';
import CEO손태욱 from '../img/CEO손태욱.png';
import CEO김종윤 from '../img/CEO김종윤.png';
import CEO이승준 from '../img/CEO이승준.png';


function CEOHistory() {


    return (
        <div className='Top-root'>
            <div className='root-main'>
                <div className='header-container'>
                    <Text variant="titlename" className='header-title'>역대 CEO 현황</Text>
                    <div className='header-title-line'></div>
                </div>
                <div className='CEOHistory-container'>
                    <div className='currentCEO-container'>
                        <div className='currentCEO-image'><img src={CEO2024}/></div>
                        <div className='currentCEO-name'>정호현 대표</div>
                        <div className='currentCEO-period'>2024 ~</div>
                    </div>
                    <div className='historyCEO-box'>
                        <div className='historyCEO-container'>
                            <div className='historyCEO-image'><img src={CEO하태민}/></div>
                            <div className='historyCEO-name'>하태민 대표</div>
                            <div className='historyCEO-period'>2022 ~ 2023</div>
                        </div>
                        <div className='historyCEO-container'>
                            <div className='historyCEO-image'><img src={CEO이기영}/></div>
                            <div className='historyCEO-name'>이기영 대표</div>
                            <div className='historyCEO-period'>2021</div>
                        </div>
                        <div className='historyCEO-container'>
                            <div className='historyCEO-image'><img src={CEO이교성}/></div>
                            <div className='historyCEO-name'>이교성 대표</div>
                            <div className='historyCEO-period'>2019 ~ 2020</div>
                        </div>
                        <div className='historyCEO-container'>
                            <div className='historyCEO-image'><img src={CEO손태욱}/></div>
                            <div className='historyCEO-name'>손태욱 대표</div>
                            <div className='historyCEO-period'>2017 ~ 2018</div>
                        </div>
                        <div className='historyCEO-container'>
                            <div className='historyCEO-image'><img src={CEO김종윤}/></div>
                            <div className='historyCEO-name'>김종윤 대표</div>
                            <div className='historyCEO-period'>2015 ~ 2016</div>
                        </div>
                        <div className='historyCEO-container'>
                            <div className='historyCEO-image'><img src={CEO이승준}/></div>
                            <div className='historyCEO-name'>이승준 대표</div>
                            <div className='historyCEO-period'>2012 ~ 2014</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        
    );

}

export default CEOHistory;